import {AnyAction} from 'redux';
import { SELECT_SUBMENU, ACTIVE_MENU, ACTIVE_MENU_NAME, ACTIVE_MENU_PARENT } from '@app/store/constants';

const initialSidebarState = {
    menuId: 0,
    activeMenuId: 0,
    activeMenuParentId: 0
};

export function sidebar(state = initialSidebarState, action: AnyAction) {
    const {payload, type} = action;

    switch (type) {
        case SELECT_SUBMENU:
            return {
                ...state,
                menuId: payload
            };

        case ACTIVE_MENU:
            return {
                ...state,
                activeMenuId: payload
            };

        case ACTIVE_MENU_PARENT:
            return {
                ...state,
                activeMenuParentId: payload
            };

        case ACTIVE_MENU_NAME:
            return {
                ...state,
                activeMenuName: payload
            };

        default:
            return state;
    }
}
